import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/_admin/cobot-setup')({
  staticData: {
    title: 'pages.cobotSetup.title',
    description: 'pages.cobotSetup.description',
  },
  component: CobotSetupPage,
});

function CobotSetupPage() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Cobot Setup</h1>
        <p className="mt-2 text-gray-600">
          Admin: Configure collaborative robots
        </p>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Cobot Configuration
        </h2>
        <p className="text-gray-600">
          This page will allow administrators to configure and manage
          collaborative robots (cobots).
        </p>
      </div>
    </div>
  );
}
